import axios from "src/lib/axios";
import { DashboardData } from "./Types";

const API_URLS = {
  GET_DASHBOARD_STATS: `/Dashboard/GetDashboardStatistics`
};

export const GetDashboardStatistics = async (): Promise<any> => {
  try {
    const response = await axios.get<DashboardData>(API_URLS.GET_DASHBOARD_STATS);
    return response?.data || {};
  } catch {
    return {};
  }
};